import { Link, Stack } from "@mui/material";
import { FC } from "react";

type MenuItem = {
  label: string;
  href: string;
};

interface DesktopNavbarProps {
  menu: MenuItem[];
}

const DesktopNavbar: FC<DesktopNavbarProps> = (props) => {
  const { menu } = props;

  return (
    <>
      <nav>
        <Stack direction="row" spacing={5}>
          {menu.map(({ label, href }) => (
            <Link
              key={label}
              href={href}
              color="inherit"
              underline="none"
              fontSize={14}
              variant="body1"
            >
              {label}
            </Link>
          ))}
        </Stack>
      </nav>
    </>
  );
};

export default DesktopNavbar;
